import * as React from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import { Table, TableBody, TableRow } from './Grid';
import Column from './Column';
import { computed, action } from 'mobx';

@observer
class GroupedColumn extends Component<any> {
    constructor(props) {
        super(props);

        if (this.props.column.groups) {
            this.setInitialGroupIndex();
        }
    }

    @action
    setInitialGroupIndex = () => {
        const selectedConfigGroupIndex = this.props.column.groups.findIndex(c => c.selected);
        const selectedGroupIndex = this.selectedGroupIndex
            ? this.selectedGroupIndex
            : (selectedConfigGroupIndex > -1)
            ? selectedConfigGroupIndex
            : 0;

        this.props.selectedGroupMap.set(this.props.columnIndex, selectedGroupIndex);
    }

    @computed
    get selectedGroupIndex() {
        return this.props.selectedGroupMap.get(this.props.columnIndex);
    }

    @computed
    get column() {
        return (this.props.column.groups) ? this.props.column.groups[this.selectedGroupIndex] : this.props.column;
    }

    render() {
        const { theme, setSelectedGroup } = this.props;
        const { column, selectedGroupIndex } = this;
        return (
            <Column
                column={column}
                selectedGroupIndex={selectedGroupIndex}
                setSelectedGroup={setSelectedGroup}
                theme={{
                    ...theme,
                    ColumnLabel: {
                        margin: "0 0 0.5em 0",
                        padding: "0 0 0.5em 0",
                        borderWidth: "1px",
                        borderStyle: "none none solid none",
                        borderColor: "gray500",
                        ...theme.ColumnGroupLabel
                    }
                }}
            >
                {
                    (column.columns && column.columns.length > 0) && (
                        <Table>
                            <TableBody>
                                <TableRow
                                    {...theme.SubColumnList}
                                >
                                    {
                                        column.columns.map((subColumn, subIndex) =>
                                            <Column
                                                key={subIndex}
                                                column={subColumn}
                                                fontSize="xs"
                                                fontFamily="body"
                                                fontWeight="regular"
                                                paddingX="0"
                                                paddingY="0"
                                                padding="1em 0 0 0"
                                                borderStyle="none"
                                                {...theme.SubColumnHeader}
                                            />
                                        )
                                    }
                                </TableRow>
                            </TableBody>
                        </Table>
                    )
                }
            </Column>
        );
    }
}

export default withTheme(GroupedColumn) as any;


// WEBPACK FOOTER //
// ./src/Components/GroupedColumn.tsx